import { Choice } from '../../../widgets/ChoiceSelector';
import Icon from '../../../widgets/Icons';
import { FlowDataViewTypes } from '../../../types';
import { COMMON_DATA_FILTERS } from '../common/data_constants';
import { DataColumn, DataColumnTypes } from '../common/DataResultTable';
import {
  FilterDropdown,
  FilterDropdownTypes,
} from '../common/filterbar/AdditionalFilterBar';

export const VIEW_TYPE: { [key: string]: FlowDataViewTypes } = {
  DEVICE: 'device',
  PROTOCOL: 'protocol',
  LOCATION: 'location',
  SITE: 'site',
  SENSOR: 'sensor',
};

export const VIEW_CHOICES: Array<Choice> = [
  { value: VIEW_TYPE.DEVICE, icon: Icon.Device, label: 'Device' },
  { value: VIEW_TYPE.PROTOCOL, icon: Icon.Protocol, label: 'Protocol' },
  { value: VIEW_TYPE.LOCATION, icon: Icon.Location, label: 'Location' },
  { value: VIEW_TYPE.SITE, icon: Icon.Site, label: 'Site' },
  { value: VIEW_TYPE.SENSOR, icon: Icon.Sensor, label: 'Sensor' },
];

export const FLOW_DATA_FILTERS = {
  DEVICE: 'device',
  PROTOCOL: 'protocol',
  LOCATION: 'location',
  SITE: 'site',
  SENSOR: 'sensor',
  DIRECTION: 'direction',
};

export const ORDERED_FILTER_KEYS = [
  // explicitly defined vs Object.values to manually set a sort order in the URL
  COMMON_DATA_FILTERS.START,
  COMMON_DATA_FILTERS.END,
  FLOW_DATA_FILTERS.DEVICE,
  FLOW_DATA_FILTERS.PROTOCOL,
  FLOW_DATA_FILTERS.LOCATION,
  FLOW_DATA_FILTERS.SITE,
  FLOW_DATA_FILTERS.SENSOR,
  FLOW_DATA_FILTERS.DIRECTION,
  COMMON_DATA_FILTERS.SORT,
];

export const SEEN_KEYS: Array<string> = [
  VIEW_TYPE.DEVICE,
  VIEW_TYPE.PROTOCOL,
  VIEW_TYPE.SITE,
];

export const INITIAL_SEEN = {
  protocol: [
    'http',
    'https',
    'http-proxy',
    'tcp',
    'udp',
    'snmp',
    'smtp',
    'ssh',
    'domain',
    'ftp',
    'tftp',
    'imap',
    'imaps',
    'rtmp',
    'sip',
    'ntp',
    'isakmp',
    'openvpn',
    'pop3',
    'pop3s',
    'ipsec',
  ],
};

export const SORT_KEYS = [
  'name',
  '-name',
  'flows',
  '-flows',
  'devices',
  '-devices',
  'bytes',
  '-bytes_in',
  '-bytes_out',
  'bytes_in',
  'bytes_out',
];

export const DEFAULT_SORT = '-bytes';

export const DATA_COLUMNS: Array<DataColumn> = [
  {
    type: DataColumnTypes.COUNT,
    field: 'devices',
    title: 'Devices',
    sortable: true,
  },
  {
    type: DataColumnTypes.COUNT,
    field: 'flows',
    title: 'Flows',
    sortable: true,
  },
  {
    type: DataColumnTypes.BYTES,
    field: 'bytes_in',
    title: 'Bytes In',
    sortable: true,
  },
  {
    type: DataColumnTypes.BYTES,
    field: 'bytes_out',
    title: 'Bytes Out',
    sortable: true,
  },
  {
    type: DataColumnTypes.BYTES,
    field: 'bytes',
    title: 'Total Bytes',
    sortable: true,
  },
  {
    type: DataColumnTypes.SPARKLINE,
    field: 'bps',
    title: 'Bits/sec',
    suffix: 'bps',
  },
];

export const FILTER_DROPDOWNS: Array<FilterDropdown> = [
  {
    type: FilterDropdownTypes.DATA,
    filterKey: FLOW_DATA_FILTERS.DEVICE,
    label: 'Device',
    placeholder: 'All devices',
    minWidth: 250,
    seenKey: 'device',
  },
  {
    type: FilterDropdownTypes.DATA,
    filterKey: FLOW_DATA_FILTERS.PROTOCOL,
    label: 'Protocol',
    placeholder: 'All protocols',
    minWidth: 145,
    seenKey: 'protocol',
  },
  {
    type: FilterDropdownTypes.LOCATION,
    filterKey: FLOW_DATA_FILTERS.LOCATION,
  },
  {
    type: FilterDropdownTypes.DATA,
    filterKey: FLOW_DATA_FILTERS.SITE,
    label: 'Site',
    placeholder: 'All sites',
    minWidth: 210,
    seenKey: 'site',
  },
  {
    type: FilterDropdownTypes.SENSOR,
    filterKey: FLOW_DATA_FILTERS.SENSOR,
  },
  {
    type: FilterDropdownTypes.DIRECTION,
    filterKey: FLOW_DATA_FILTERS.DIRECTION,
  },
];
